import { createBrowserRouter, RouterProvider } from "react-router-dom";
import RelatedList from "./Pages/RelatedList";
import SettingsRoute from "./Pages/SettingsRoute";
import CustomAction from "./Pages/CustomAction";
// import Webtab from "./Pages/Webtab";
// import Businesscard from "./Pages/Businesscard";
import Button from "./Pages/Button";

function App() {
  const router = createBrowserRouter([
    {
      path: "/relatedlist",
      element: <RelatedList />,
    },
    {
      path: "/settings",
      element: <SettingsRoute />,
    },
    {
      path: "/customaction",
      element: <CustomAction />,
    },
    // {
    //   path: "/webtab",
    //   element: <Webtab />,
    // },
    // {
    //   path: "/businesscard",
    //   element: <Businesscard />,
    // },
    {
      path: "/buttons",
      element: <Button />,
    },
  ]);
  return <RouterProvider router={router} />;
}

export default App;
